export default "__VITE_ASSET__J5Yim9xh__"